export default __webpack_public_path__ + "static/media/check-green.31cc73fc.svg";